<template>
  <div :id="componentId" class="sp1-core-activities" :style="sectionStyle">
    <div class="carousel flex-row">
      <img
        class="arrow arrow-left"
        referrerpolicy="no-referrer"
        src="../assets/img/FigmaDDSSlicePNG99bb8919a69e1287d3f76ac4a83127c7.png"
        @click="prev"
      />
      <div
        v-for="(activity, idx) in activities"
        :key="idx"
        class="activity-card flex-col"
        :class="{ active: idx === activeIndex }"
      >
        <div class="activity-tag-bar flex-col">
          <span class="activity-tag" v-html="formatLines(activity.tag)"></span>
        </div>
        <div class="activity-divider"></div>
        <div class="activity-info flex-col justify-between">
          <span class="activity-title" v-html="formatLines(activity.title)"></span>
          <div class="activity-date">
            <p class="date-label">发布时间</p>
            <p class="date-value">{{ activity.dateRange }}</p>
            <p class="date-label">发布时间</p>
            <p class="date-value">{{ activity.date }}</p>
          </div>
        </div>
      </div>
      <img
        class="arrow arrow-right"
        referrerpolicy="no-referrer"
        src="../assets/img/FigmaDDSSlicePNG33a817cb60e4551109bd46ed91b16c20.png"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreActivities',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_10'
    }
  },
  data() {
    return {
      activeIndex: 1,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      activities: [
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一部权威年度\n发展报告',
          title: '2026中国区域农业\n品牌发展报告',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
        padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  },
  methods: {
    prev() {
      this.activeIndex = (this.activeIndex - 1 + this.activities.length) % this.activities.length;
    },
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.activities.length;
    },
    formatLines(text) {
      return text.replace(/\n/g, '<br>');
    }
  }
};
</script>

<style scoped>
.sp1-core-activities {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 39px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.carousel {
  position: relative;
  width: 1400px;
  height: 394px;
  margin-top: 11px;
  align-items: center;
}

.activity-card {
  flex-shrink: 0;
  width: 210px;
  height: 360px;
  margin-left: 20px;
  background-color: rgba(243, 246, 243, 1);
}

.activity-card:first-of-type {
  margin-left: 19px;
}

.activity-card.active {
  width: 350px;
  height: 394px;
}

.activity-tag-bar {
  width: 100%;
  height: 90px;
  background-image: linear-gradient(
    90deg,
    rgba(43, 131, 120, 1) 0,
    rgba(48, 133, 122, 0) 100%
  );
  justify-content: center;
}

.activity-tag {
  width: 128px;
  height: 52px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  letter-spacing: 1.1764706373214722px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  line-height: 26px;
}

.activity-card.active .activity-tag {
  width: 150px;
}

.activity-divider {
  width: 36px;
  height: 8px;
  border-radius: 4px;
  background-color: rgba(56, 138, 128, 1);
  margin: 26px 0 0 17px;
}

.activity-info {
  width: 176px;
  height: 206px;
  margin: 12px 0 18px 17px;
}

.activity-card.active .activity-info {
  width: 316px;
}

.activity-title {
  width: 176px;
  height: 60px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  letter-spacing: 1.1764706373214722px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  line-height: 30px;
}

.activity-card.active .activity-title {
  width: 316px;
}

.activity-date {
  width: 84px;
  height: 120px;
  margin-top: 26px;
}

.date-label {
  width: 84px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  letter-spacing: 0.8235294222831726px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  line-height: 30px;
  margin: 0;
}

.date-value {
  width: 84px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(45, 132, 121, 1);
  font-size: 16px;
  letter-spacing: 0.9411764740943909px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  line-height: 30px;
  margin: 0;
}

.arrow {
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  cursor: pointer;
}

.arrow-left {
  margin-left: 0;
}

.arrow-right {
  margin-left: 19px;
}
</style>
